import { cloudChiprApi } from "../../../../../../services/cloudchipr.api";
import { RootState } from "@/store/store";
import { currentDashboardIdSelector } from "@/store/dashboards/selectors/dashboard/currentDashboardIdSelector";
import { dashboardDimensionsCategoryIdsByDashboardIdSelector } from "@/store/dashboards/selectors/dashboard/filters/dashboardDimensionsCategoryIdsByDashboardIdSelector";
import { dashboardDatesByDashboardIdSelector } from "@/store/dashboards/selectors/dashboard/filters/dashboardDatesByDashboardIdSelector";
import { covertDatesToQueryParam } from "@/components/common/date-range-picker/utils/helpers/covertDatesToQueryParam";
import { widgetInheritsDatesByIdSelector } from "@/store/dashboards/selectors/widgets/common/widgetInheritsDatesByIdSelector";

const selector =
  cloudChiprApi.endpoints
    .getUsersMeOrganisationsCurrentWidgetsCostBreakdownByWidgetId.select;

export const billingExplorerWidgetByWidgetIdSelector = (
  state: RootState,
  widgetId: string,
) => {
  const dashboardId = currentDashboardIdSelector(state);
  const categoryId = dashboardDimensionsCategoryIdsByDashboardIdSelector(
    state,
    dashboardId ?? "",
  )?.category_id;

  const dashboardDates = dashboardDatesByDashboardIdSelector(
    state,
    dashboardId ?? "",
  );

  let payload = {
    widgetId,
    categoryId: categoryId ?? undefined,
  };

  const inheritDates = widgetInheritsDatesByIdSelector(state, widgetId);

  if (inheritDates && dashboardDates) {
    payload = {
      ...payload,
      ...covertDatesToQueryParam(dashboardDates),
    };
  }

  return selector(payload)(state);
};
